export class ISO8601 {
    static regexp = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;

    private static dateParser = (key, value) => {
        if (typeof value === 'string') {
            const a = ISO8601.regexp.exec(value);
            if (a) return new Date(value);
        }
        return value;
    };

    /**
     * Globally enables JSON date parsing for JSON.parse().
     * Replaces the default JSON.parse() method and adds
     * the dateParser() extension to the processing chain.
     * @param key - property name that is parsed
     * @param value - property value
     * @returns date or the original value if not a date string
     */
    static overrideJsonParser = () => {
        if (JSON) {
            const originalJsonParser = JSON.parse;
            JSON.parse = json => {
                try {
                    return originalJsonParser(json, ISO8601.dateParser);
                } catch (e) {
                    // original error thrown has no error message so rethrow with message
                    throw new Error('JSON content could not be parsed');
                }
            };
        } else {
            console.error('Could not initialise ISO8601 Date Parser');
        }
    };
}
